import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexLpDetailsWidgetSettings, DexLpDetailsWidgetSettingsDef} from './dex-lp-details-widget-settings';

@Injectable()
export class DexLpDetailsWidgetSettingsService implements WidgetSettingsService {

    public getDefaultSettings(): Observable<DexLpDetailsWidgetSettings> {
        return this.fromDefinition({
            title: null
        });
    }

    public fromDefinition(settingsDef: DexLpDetailsWidgetSettingsDef): Observable<DexLpDetailsWidgetSettings> {
        return of<DexLpDetailsWidgetSettings>({
            title:    settingsDef.title,
            features: settingsDef.features
        });
    }

    public toDefinition(settings: DexLpDetailsWidgetSettings): DexLpDetailsWidgetSettingsDef {
        return {
            title: settings.title
        };
    }

}
